// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"58":"55893fdf","694":"c1ab5ca7"}[chunkId] + ".chunk.js";
};